<template>
  <aside class="menu">
    <p class="menu-label">{{ $t("select program") }}</p>
    <ul class="menu-list">
      <li v-for="(program, pidx) in programs" :key="pidx">
        <a
          :class="{
            'is-active': program.uuid == selected_program.uuid,
          }"
          @click="select_program(program)"
        >
          <span
            class="icon"
            :class="{
              'has-text-success': program.has_pensums,
              'has-text-danger': !program.has_pensums,
            }"
          >
            <i class="fa fa-book"></i>
          </span>
          {{ program.name }}</a
        >
      </li>
    </ul>
  </aside>
</template>

<script>
import { get } from "@/utils";

export default {
  name: "ProgramSelector",
  data() {
    return {
      programs: [],
      selected_program: {},
    };
  },
  methods: {
    get_programs() {
      let v = this;
      get("/student/program/all", {})
        .then((programs) => {
          v.programs = programs.sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    select_program(program) {
      this.selected_program = program;
      this.$emit("program-selected", program);
    },
  },
  mounted() {
    this.get_programs();
  },
};
</script>

<style scoped>
.menu a.is-active {
  background-color: #00d1b2;
  color: white;
}
</style>
